module.exports = __webpack_public_path__ + "static/img/作品82.8800c14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/作品82.png
// module id = Y90w
// module chunks = 1